class QuickViewButton extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready === 'true') return;
    this.dataset.ready = 'true';
    this.setAttribute('role', 'link');
    this.tabIndex = 0;
    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.openProduct();
    });
    this.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        this.openProduct();
      }
    });
  }

  openProduct() {
    const productUrl = this.dataset.productUrl;
    if (productUrl) window.location.assign(productUrl);
  }
}
if (!customElements.get('quick-view-button')) {
  customElements.define('quick-view-button', QuickViewButton);
}